import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiActivity, FiSearch, FiTool, FiPercent, FiPhone, FiMessageSquare, FiSettings } = FiIcons;

const Sidebar = ({ isOpen, onClose }) => {
  const menuItems = [
    { icon: FiMessageSquare, label: 'Chat Assistant', active: true },
    { icon: FiSearch, label: 'Inventory' },
    { icon: FiTool, label: 'Service & Detailing' },
    { icon: FiPercent, label: 'Price Drops' },
    { icon: FiPhone, label: 'Contact Us' },
    { icon: FiSettings, label: 'Settings' }
  ];

  const handleMenuClick = (item) => {
    if (window.innerWidth < 1024) onClose();
  };

  const handleCallDealer = () => {
    window.location.href = 'tel:+18337063089';
  };

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={onClose}
          />
        )}
      </AnimatePresence>

      <motion.div
        initial={{ x: -280 }}
        animate={{ x: isOpen ? 0 : -280 }}
        className="fixed lg:relative lg:translate-x-0 w-72 h-full bg-gray-800 border-r border-gray-700 z-50 flex flex-col"
      >
        <div className="p-6 border-b border-gray-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiActivity} className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="font-bold text-lg text-white leading-tight">Carson</h1>
                <p className="text-sm text-gray-400">Exports</p>
              </div>
            </div>
            <button onClick={onClose} className="lg:hidden p-2 text-gray-400 hover:text-white">
              <SafeIcon icon={FiX} className="w-5 h-5" />
            </button>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          {menuItems.map((item, index) => (
            <motion.button
              key={index}
              whileHover={{ x: 5 }}
              onClick={() => handleMenuClick(item)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                item.active ? 'bg-blue-600 text-white shadow-lg' : 'text-gray-300 hover:bg-gray-700'
              }`}
            >
              <SafeIcon icon={item.icon} className="w-5 h-5" />
              <span>{item.label}</span>
            </motion.button>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-700">
          <div className="bg-gray-700/50 border border-gray-600 rounded-xl p-4">
            <h3 className="font-semibold text-white mb-1">Located in Dartmouth</h3>
            <p className="text-xs text-gray-400 mb-3">550 Windmill Rd, NS</p>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleCallDealer}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-lg"
            >
              Call 833-706-3089
            </motion.button>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;